module.exports = __webpack_public_path__ + "img/quest_icon_0055_deathcoins.8f92c5ad.png";